/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                             
*/
import { VisionApplication } from '../../application';
import { TimeSelect } from '../../components/timeselect';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';

export class VisionGeofenceReportWindow extends VisionWindow {
    layout!: dhtmlXLayoutObject;
    paramForm!: dhtmlXForm;
    geofenceGrid!: dhtmlXGridObject;
    assetGrid!: dhtmlXGridObject;

    constructor(manager: VisionWindowManager) {
        super(manager, {
            id: 'geofence_report_window',
            title: 'Geofence Report',
            x: 30,
            y: 30,
            width: 600,
            height: 500,
        });
        this.window.setText('Geofence Report');

        this.buildLayout();
        this.populateGeofenceTable();
        this.populateAssetTable();
        this.buildEvents();
    }

    private buildLayout(): void {
        this.layout = this.window.attachLayout('2U');
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();

        const formData = JSON.parse(JSON.stringify(TimeSelect.FORM));
        formData.push({
            type: 'radio',
            name: 'report_type',
            value: 'by_geofence',
            label: 'By Geofence',
            checked: true,
        });
        formData.push({
            type: 'radio',
            name: 'report_type',
            value: 'by_asset',
            label: 'By Asset',
            checked: false,
        });
        formData.push({ type: 'button', value: 'Download Report', name: 'search' });
        this.paramForm = this.layout.cells('a').attachForm(formData);
        this.paramForm.getInput(TimeSelect.START).autocomplete = 'off';

        this.layout.cells('b').showView('geofence');
        this.geofenceGrid = this.layout.cells('b').attachGrid();
        this.geofenceGrid.setHeader('Name', '', []);
        this.geofenceGrid.setColTypes('ro');
        this.geofenceGrid.init();

        this.layout.cells('b').showView('asset');
        this.assetGrid = this.layout.cells('b').attachGrid();
        this.assetGrid.setHeader('Name', '', []);
        this.assetGrid.setColTypes('ro');
        this.assetGrid.init();

        this.layout.cells('b').showView('geofence');
    }

    /** Populate the Geofence grid list with the names of the available geofences.
     *
     */
    private populateGeofenceTable(): void {
        const request = VisionApplication.getInstance().geofenceService.cachedFetchData();

        request.then((data) => {
            data.forEach((geofence) => {
                this.geofenceGrid.addRow(geofence.id.id, [geofence.id.name], 0, '', '', false);
            });
        });
    }

    /** Populate the Asset grid list with the names of the available assets.
     *
     */
    private populateAssetTable(): void {
        const assetList = VisionApplication.getInstance().assetService.assetList;

        assetList.forEach((asset) => {
            this.assetGrid.addRow(asset.id.id, [asset.id.name], 0, '', '', false);
        });
    }

    private buildEvents(): void {
        // Event Form was changed
        this.paramForm.attachEvent('onChange', (name, value, _state) => {
            if (name == TimeSelect.SELECT) {
                const select = new TimeSelect(this.paramForm);
                select.selectRange(value as string);
            }

            if (name == 'report_type') {
                if (value == 'by_geofence') {
                    this.layout.cells('b').showView('geofence');
                } else if (value == 'by_asset') {
                    this.layout.cells('b').showView('asset');
                }
            }
        });

        // Download Report Button selected
        this.paramForm.attachEvent('onButtonClick', (_id) => {
            this.getReport();
        });
    }

    /** Builds the request to get the report
     *
     */
    private getReport(): void {
        const service = VisionApplication.getInstance().geofenceService;

        const startTime = this.paramForm.getItemValue(TimeSelect.START);
        const endTime = this.paramForm.getItemValue(TimeSelect.END);
        const reportType = this.paramForm.getCheckedValue('report_type');

        if (startTime == null || endTime == null || reportType == null) {
            dhtmlx.message({
                title: 'Missing Information',
                text: 'Please select start/end times.',
                type: 'alert-error',
            });
            return;
        }

        if (reportType == 'by_geofence') {
            const geofenceId = this.geofenceGrid.getSelectedRowId();
            if (geofenceId == null) {
                dhtmlx.message({
                    title: 'No Geofence',
                    text: 'Please select a geofence.',
                    type: 'alert-error',
                });
                return;
            }
            const geofenceName = this.geofenceGrid.cellById(geofenceId, 0).getValue();
            service.downloadPDF('/report/geofence/geofence?start=' + startTime.getTime() + '&end=' + endTime.getTime() + '&geofence=' + geofenceId, 'Geofence-' + geofenceName + '.pdf');
        } else if (reportType == 'by_asset') {
            const assetId = this.assetGrid.getSelectedRowId();
            if (assetId == null) {
                dhtmlx.message({
                    title: 'No Asset',
                    text: 'Please select an asset.',
                    type: 'alert-error',
                });
            }
            const assetName = this.assetGrid.cellById(assetId, 0).getValue();
            service.downloadPDF('/report/geofence/asset?start=' + startTime.getTime() + '&end=' + endTime.getTime() + '&asset=' + assetId, 'Geofence-' + assetName + '.pdf');
        }
    }
}
